<ng-template #details let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ displaydetails.title }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="mb-3" *ngIf="displaydetails">
			<h4></h4>
			<ng-container *ngIf="displaydetails.type == 'html'">
				<div [innerHTML]="displaydetails.display">
				</div>
			</ng-container>
			<ng-container *ngIf="displaydetails.type == 'pdf'">
				<ngx-extended-pdf-viewer [base64Src]="displaydetails.display" useBrowserLocale="true" [handTool]="false" [textLayer]="true" [showOpenFileButton]="false" [showPropertiesButton]="false" [showHandToolButton]="true" [filenameForDownload]="displaydetails.title"></ngx-extended-pdf-viewer>
			</ng-container>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #orderDetails let-modal>
	<div class="modal-header">
		<div class="modal-title row m-0 p-0 w-100 align-items-center" id="modal-title">
			<h4 class="mb-0">Order# {{orderdetails.header.orderno}}</h4>
			<span *ngIf="orderdetails.header.tpl3pl_remote_order_id" class="ml-2 text-muted small align-middle">3PL ID: {{ orderdetails.header.tpl3pl_remote_order_id }}</span>
			<span class="ml-auto d-flex align-items-center" style="gap: 12px;">
				<span class="text-muted small"><strong>Ship Via:</strong> {{ orderdetails.header.shippername }}</span>
				<span class="text-muted small"><strong>Wanted:</strong> {{ orderdetails.header.datewanted }}</span>
				<span class="text-muted small"><strong>By:</strong> {{ orderdetails.header.enteredby }}</span>
				<span class="text-muted small"><strong>Created:</strong> {{ orderdetails.header.date_created }}</span>
			</span>
		</div>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body">
		<div class="mb-3" *ngIf="orderdetails">
			<div *ngIf="orderdetails.dispatch_details && orderdetails.dispatch_details.status_id == '29'">
				<div #mapDiv class="w-100" [ngClass]="{'d-none': !orderdetails.dispatch_details.nextlast}">
					EST: {{orderdetails.dispatch_details.nextlast}}
					<div class="w-100" id="map"></div>
				</div>
			</div>

			<div class="row border-bottom pb-2 pt-2 mb-2" style="background: #f8f9fa;">
				<div class="col-12 d-flex align-items-center" style="gap: 16px;">
					<span class="badge badge-secondary" style="font-size: 0.85em; padding: 6px 10px;">
						Terms: {{ orderdetails.header.payterms }}
					</span>
					<ng-container *ngIf="orderdetails.preauthdetails && !orderdetails.preauthdetails.new_auth">
						<span class="badge badge-success" style="font-size: 0.85em; padding: 6px 10px;">
							<i class="material-icons" style="font-size: 14px; vertical-align: middle;">credit_card</i>
							Pre-Auth: {{ orderdetails.preauthdetails.authtotal | currency }}
						</span>
					</ng-container>
				</div>
			</div>

			<div class="row mt-2 mb-2 border-bottom pb-2">
				<div class="col-md-3">
					<h6 class="mb-1 font-weight-bold">Ship To:</h6>
					<span class="lesser" [innerHTML]="orderdetails.header.shipto"></span>
				</div>
				<div class="col-md-3">
					<h6 class="mb-1 font-weight-bold">Contact:</h6>
					<span class="lesser">{{orderdetails.header.contactphone}}</span>
					<ng-container *ngIf="orderdetails.header.contactemail && orderdetails.header.contactemail != ''">
						<br>
						<a class="lesser" [href]="'mailto:' + orderdetails.header.contactemail">{{orderdetails.header.contactemail}}</a>
					</ng-container>
				</div>
				<div class="col-md-3">
					<h6 class="mb-1 font-weight-bold">Notes:</h6>
					<span class="lesser" [innerHTML]="orderdetails?.header?.comments"></span>
				</div>
				<div class="col-md-3">
					<h6 class="mb-1 font-weight-bold">History:</h6>
					<ng-container *ngIf="orderdetails.dispatch_details.dispatch_id">
						<ul class="mt-1 mb-0 pl-3" style="font-size: 0.85em;">
							<li *ngIf="orderdetails.dispatch_details.truck_name">
								{{ orderdetails.dispatch_details.truck_name }}
								<span class="text-muted" *ngIf="orderdetails.dispatch_details.driveruserid"> - {{ orderdetails.dispatch_details.driveruserid }}</span>
							</li>
							<li *ngIf="orderdetails.dispatch_details.datecreated !='0000-00-00 00:00:00'">
								Dispatched: {{ orderdetails.dispatch_details.datecreated | date:'shortDate' }}
								{{ orderdetails.dispatch_details.datecreated | date:'shortTime' }}
							</li>
							<li *ngIf="orderdetails.dispatch_details.delivery_date !='0000-00-00 00:00:00'">
								Delivered: {{ orderdetails.dispatch_details.delivery_date | date:'shortDate' }}
								{{ orderdetails.dispatch_details.delivery_date | date:'shortTime' }}
							</li>
						</ul>
					</ng-container>
					<span *ngIf="!orderdetails.dispatch_details.dispatch_id" class="text-muted lesser">N/A</span>
				</div>
			</div>
			<div class="table-responsive mt-3">
				<table class="table table-bordered table-striped table-hover normal">
					<thead class="thead-dark">
						<tr>
							<th>ITEM</th>
							<th>DESC</th>
							<th class="text-center">QOH</th>
							<th class="text-center">ORDERED</th>
							<th class="text-center">INVOICED</th>
							<th class="text-center">OUTSTANDING</th>
							<th class="text-right">PRICE</th>
							<th class="text-right" *ngIf="config.discounts">DISCOUNT</th>
							<th class="text-right">TOTAL</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of orderdetails.details">
							<td>
								<button mat-icon-button (click)="copyToClipboard(item.stkcode)" class="ml-2" title="Copy to clipboard">
									<mat-icon>content_copy</mat-icon>
								</button>
								<a *ngIf="!issalesman" [routerLink]="'/inventory/view/'+item.stkcode" (click)="modal.dismiss('route change')">{{item.stkcode}}</a>
								<span *ngIf="issalesman">{{item.stkcode}}</span>
							</td>
							<td>{{item.description}}</td>
							<td class="text-center">{{item.qoh}}</td>
							<td class="text-center">{{item.ordered}}</td>
							<td class="text-center">{{item.qtyinvoiced}}</td>
							<td class="text-center">{{item.ordered - item.qtyinvoiced}}</td>
							<td class="text-right">{{item.unitprice | currency}}</td>
							<td class="text-right" *ngIf="config.discounts">{{item.discountpercent | percent }}</td>
							<td class="text-right">{{item.discountprice * item.ordered | currency}}</td>
						</tr>
					</tbody>
					<tfoot>
						<tr *ngFor="let t of orderdetails.saved_totals">
							<ng-container *ngIf="config.discounts">
								<td colspan="7"></td>
							</ng-container>
							<ng-container *ngIf="!config.discounts">
								<td colspan="6"></td>
							</ng-container>
							<td class="text-right">{{ t.title }}:</td>
							<td class="text-right">{{t.text | currency}}</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<div class="main-content bg-white">
    <div class="row m-0 p-0">
        <div class="col-3">
            <mat-form-field appearance="outline">
                <mat-label>Transaction Dates</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate [formControl]="fromdateCtrl" placeholder="Start date" >
                    <input matEndDate [formControl]="todateCtrl" placeholder="End date" (dateChange)="updateTransactions();">
                </mat-date-range-input>
                <mat-hint *ngIf="config?.env?.client !== 'summit'">MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-hint *ngIf="config?.env?.client === 'summit'">DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="col-3">
            <mat-label>Location</mat-label>
            <mat-select multiple [formControl]="selected_locations" appSelectAll>
                <mat-option *ngFor="let loc of locations" [value]="loc.loccode">{{loc.locationname}}</mat-option>
            </mat-select>    
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="!posuser && !issalesman" class="col-3">
            <mat-label>Source</mat-label>
            <mat-select [formControl]="selected_sources" appSelectAll multiple>
                <mat-option *ngFor="let s of sources" [value]="s.value">{{s.view | uppercase}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="!issalesman && !posuser" class="col-3">
            <mat-label>User</mat-label>
            <mat-select multiple appSelectAll [formControl]="selected_salespeople">
                <mat-option [value]="'any'">Any</mat-option>
                <mat-option *ngFor="let p of allusers" [value]="p.userid">{{p.realname}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    
    <div class="row m-0 p-0">
        <div class="col-12">
            <mat-form-field appearance="outline" class="w-100 m-0 p-0">
                <mat-label>Search</mat-label>
                <input matInput (keyup)="applyFilter($event)" #search placeholder="Filter results..." [formControl]="searchbar">
                <!-- <mat-icon matPrefix>search</mat-icon> -->
                <span matSuffix class="d-flex align-items-center">
                    <button mat-icon-button class="text-success" title="Export XLS" (click)="export('xls'); $event.preventDefault(); $event.stopPropagation(); search.blur();" [disabled]="fetching" [ngClass]="{'greyscale': fetching}">
                        <mat-icon *ngIf="!exportingxls">grid_on</mat-icon>
                        <svg *ngIf="exportingxls" class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </button>
                    <button mat-icon-button class="text-danger" title="Export PDF" (click)="export('pdf'); $event.preventDefault(); $event.stopPropagation(); search.blur();" [disabled]="fetching" [ngClass]="{'greyscale': fetching}">
                        <mat-icon *ngIf="!exportingpdf">picture_as_pdf</mat-icon>
                        <svg *ngIf="exportingpdf" class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </button>
                    <button class="d-ruby" mat-flat-button color="primary" title="Run" (click)="search.blur(); $event.preventDefault(); $event.stopPropagation(); loadorderdata();" [disabled]="fetching" [ngClass]="{'greyscale': fetching}">
                        RUN&nbsp;
                        <mat-icon *ngIf="!fetching">play_arrow</mat-icon>
                        <svg *ngIf="fetching" class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </button>
                </span>
            </mat-form-field>
        </div>
    </div>
    

  

  

   


	<div class="table-responsive data-table table-head-dark table-striped " *ngIf="datasource && !fetching">
		<table mat-table [dataSource]="datasource" matSort class="mat-elevation-z2 w-100">

			<ng-container matColumnDef="orderstatus">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
				<td mat-cell *matCellDef="let row">
                    <span class="order-status-pill status-{{ row.orderstatusid }}" [ngStyle]="row | statusBadgeNgStyle">
                        {{ row.statusname == 'CALL QBC NOW' ? 'Complete' : row.statusname }}
                    </span>
                </td>
			</ng-container>

			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Order # </th>
				<td mat-cell *matCellDef="let row" class="cursor" (click)="viewInvoicedOrder(row.orderno, orderDetails)"> 
                    <b class="text-underline cursor" matTooltip="View Order">{{row.orderno }}</b>
                </td>
			</ng-container>

			<ng-container matColumnDef="debtorno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Customer </th>
				<td mat-cell *matCellDef="let row"> 
                    <b>{{row.debtorno}}.{{row.branchcode}}</b>&nbsp;&nbsp;
                    <span class="font-weight-lighter">{{row.brname}}</span>
                </td>
			</ng-container>

            <ng-container matColumnDef="location">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Loc </th>
				<td mat-cell *matCellDef="let row"> {{row.fromstkloc}}</td>
			</ng-container>

            <ng-container matColumnDef="units">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> units </th>
				<td mat-cell *matCellDef="let row"> {{row.units}}</td>
			</ng-container>

            <ng-container matColumnDef="payterms">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Terms </th>
				<td mat-cell *matCellDef="let row"> {{row.payterms | uppercase}}</td>
			</ng-container>

            <ng-container matColumnDef="total">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Total </th>
				<td mat-cell *matCellDef="let row" class="font-weight-bold"> {{row.total | currency}} </td>
			</ng-container>

			<ng-container matColumnDef="orddate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Order Date </th>
				<td mat-cell *matCellDef="let row" class="font-weight-lighter"> {{ config?.env?.client === 'summit' ? row.date_created : (row.date_created | date: 'short') }} </td>
			</ng-container>

			<ng-container matColumnDef="comments">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Comments </th>
				<td mat-cell *matCellDef="let row" class="font-weight-lighter font-size-md">
                    <ng-container *ngIf="row.comments.length">{{row.comments }}</ng-container>
                    <ng-container *ngIf="!row.comments.length">
                        <mat-icon class='empty-icon'>remove</mat-icon>
                    </ng-container>      
                </td>
			</ng-container>

			<ng-container matColumnDef="stkcode">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Item Code </th>
				<td mat-cell *matCellDef="let row"> 
                    <div>{{row.stkcode}}</div> 
                    <div class="font-weight-lighter font-size-md">{{row.description}}</div> 
                </td>
			</ng-container>

			<ng-container matColumnDef="quantity">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Qty </th>
				<td mat-cell *matCellDef="let row"> {{row.quantity}} </td>
			</ng-container>

			<ng-container matColumnDef="unitprice">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Unit Price </th>
				<td mat-cell *matCellDef="let row"> {{row.unitprice | currency}} </td>
			</ng-container>

            <ng-container matColumnDef="source">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Source </th>
				<td mat-cell *matCellDef="let row" class="text-left">
                    <span class="source-dot" [ngClass]="'source-' + row.placedfrom"></span>
                    {{row.name | uppercase}}
                </td>
			</ng-container>

			<ng-container matColumnDef="transno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Trans # </th>
				<td mat-cell *matCellDef="let row" [ngClass]="{'cursor text-underline-trans': row.transno}" [attr.colspan]="row.transno ? 1 : 2" [class.text-center]="!row.transno" [class.w-100]="!row.transno" (click)="openDocument(row,details,'pdf')">
                    <span *ngIf="row.transno" matToolTip="View Invoice">{{row.transno}}</span>
                    <span *ngIf="!row.transno" class="badge badge-not-invoiced" title="Order has not been invoiced yet">Not Invoiced</span>
                </td>
			</ng-container>

			<ng-container matColumnDef="trandate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Trans Date </th>
				<td mat-cell *matCellDef="let row" [class.d-none]="!row.transno" class="font-weight-lighter"> {{ config?.env?.client === 'summit' ? row.inputdate : (row.inputdate | date:'short') }} </td>
			</ng-container>

			<ng-container matColumnDef="salesmancode">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> SLSM# </th>
				<td mat-cell *matCellDef="let row"> {{row.salesmancode}} </td>
			</ng-container>

			<ng-container matColumnDef="salesmanname">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Salesman </th>
				<td mat-cell *matCellDef="let row"> {{row.salesmanname}} </td>
			</ng-container>

			<ng-container matColumnDef="username">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> User </th>
				<td mat-cell *matCellDef="let row"> 
                    <ng-container *ngIf="row.username">{{row.username}} </ng-container>
                    <ng-container *ngIf="!row.username">
                        <mat-icon class='empty-icon'>remove</mat-icon>
                    </ng-container>
                </td>
			</ng-container>

            <ng-container matColumnDef="enteredby">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Entered / Taken</th>
				<td mat-cell *matCellDef="let row"> 
                    <ng-container *ngIf="row.enteredby">{{row.enteredby}} </ng-container>
                    <ng-container *ngIf="!row.enteredby">
                        <mat-icon class='empty-icon'>remove</mat-icon>
                    </ng-container>
                    &nbsp;/&nbsp;
                    <ng-container *ngIf="row.takenby">{{row.takenby}} </ng-container>
                    <ng-container *ngIf="!row.takenby">
                        <mat-icon class='empty-icon'>remove</mat-icon>
                    </ng-container>
                </td>
			</ng-container>

           

			<ng-container matColumnDef="manager">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Manager </th>
				<td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.manager">{{row.manager}}</ng-container>
                    <ng-container *ngIf="!row.manager">
                        <mat-icon class='empty-icon'>remove</mat-icon>
                    </ng-container>
                </td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;" class="p-2 row-bg-{{row.ordertype}}"></tr>

			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                    <h4 class="p-4 font-weight-lighter">No data found for selected date range and filters</h4>
                </td>
			</tr>

		</table>
	</div>

	<div class="row m-0 p-0">
        <div class="col-8 d-flex">
            <div>
                <div class="row p-1">
                    <button mat-icon-button class="legend-pill" (click)="showtotals = !showtotals" matToolTip="Show source totals?" *ngIf="!posuser">
                        <mat-icon [ngClass]="{'text-success': showtotals}">attach_money</mat-icon>
                    </button>
                    <div class="legend-pill ml-1" *ngIf="!posuser">Back Office
                        <span class="pill-count">{{orders_backoffice.count}}</span>
                        <span class="pill-count" [ngClass]="{'totals' : showtotals, 'totals-h' : !showtotals}">{{orders_backoffice.total | currency}}</span>
                    </div>
                    <div class="legend-pill ml-1">POS
                        <span class="pill-count">{{orders_pos.count}}</span>
                        <span class="pill-count" [ngClass]="{'totals' : showtotals, 'totals-h' : !showtotals}">{{orders_pos.total | currency}}</span>
                    </div>
                    <div class="legend-pill ml-1" *ngIf="!posuser">Salesperson
                        <span class="pill-count">{{orders_salesperson.count}}</span>
                        <span class="pill-count" [ngClass]="{'totals' : showtotals, 'totals-h' : !showtotals}">{{orders_salesperson.total | currency}}</span>
                    </div>
                    <div class="legend-pill ml-1" *ngIf="!posuser">WEB
                        <span class="pill-count">{{orders_web.count}}</span>
                        <span class="pill-count" [ngClass]="{'totals' : showtotals, 'totals-h' : !showtotals}">{{orders_web.total | currency}}</span>
                    </div>
                    <div class="legend-pill ml-1">Total
                        <span class="pill-count">{{orders_total | currency}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
            <mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons [ngClass]="{'d-none': fetching || !datasource}"></mat-paginator>
        </div>
    </div>

    <!-- <div *ngIf="fetching" class="row text-center w-100">
        <svg class="spinner" width="100px" height="100px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
    </div> -->
</div>
